// Client side of the profile-security edge function (Security view of the
// staff Profile page + the email two-factor gate), plus the "remember this
// device" token. The token is random and opaque; the server stores only its
// hash, so leaking localStorage alone doesn't forge a trusted device.
import { supabase } from '../supabaseClient';

const DEVICE_KEY = 'mayday-mfa-device';

export function getDeviceToken() {
  try { return localStorage.getItem(DEVICE_KEY) || null; } catch { return null; }
}

export function setDeviceToken(token) {
  try {
    if (token) localStorage.setItem(DEVICE_KEY, token);
    else localStorage.removeItem(DEVICE_KEY);
  } catch { /* storage unavailable */ }
}

export function clearDeviceToken() {
  setDeviceToken(null);
}

/**
 * POST { op, ...fields } to profile-security as the signed-in user. Resolves
 * with the JSON body; rejects with an Error carrying the server's message
 * (and `status`) so callers can show it verbatim.
 */
export async function profileSecurity(op, fields = {}) {
  const { data: { session } } = await supabase.auth.getSession();
  if (!session?.access_token) throw new Error('Not signed in');
  const resp = await fetch(`${process.env.REACT_APP_SUPABASE_URL}/functions/v1/profile-security`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${session.access_token}`,
    },
    body: JSON.stringify({ op, ...fields }),
  });
  let body = null;
  try { body = await resp.json(); } catch { /* non-JSON error page */ }
  if (!resp.ok || body?.error) {
    const err = new Error(body?.error || `Request failed (${resp.status})`);
    err.status = resp.status;
    err.body = body;
    throw err;
  }
  return body;
}
